<template>
  <BaseModal
    :show="show"
    :height="height"
    title="Dokumente hochladen"
    @close="$emit('update:show', false)"
    @closed="height = MODAL_HEIGHT_WITHOUT_FILES"
  >
    <DocumentUpload v-if="show" @files-set="handleModalHeight" />
  </BaseModal>
</template>

<script setup lang="ts">
import DocumentUpload from '@/upload/components/UploadView.vue';
import BaseModal from '@/application/components/BaseModal.vue';
import { ref } from 'vue';

defineProps<{ show: boolean }>();
defineEmits(['update:show']);

const MODAL_HEIGHT_WITH_FILES = '92%';
const MODAL_HEIGHT_WITHOUT_FILES = '280px';

const height = ref('280px');

function handleModalHeight(hasFiles: boolean) {
  height.value = hasFiles ? MODAL_HEIGHT_WITH_FILES : MODAL_HEIGHT_WITHOUT_FILES;
}
</script>
